import { ChartTypes } from '~/modules/SDK/Chart2/ChartTypes'
import { PineJS } from '~/modules/SDK/Chart2/PineJS'

/**
 * 計算序列資料的最小值
 * @param this
 * @param series 數列
 * @param length 期數
 * @returns number
 */
export function lowest(
  this: ChartTypes.IndicatorThis,
  series: PineJS.NewVar<number>,
  length: number,
): number {
  return this.extremeValue(series, length, -1)
}
